import { createSelector } from 'reselect';

import * as loadingState from '@blueberry/constants/loadingState';

export const types = {
  RESET_USER: 'RESET_USER',
  FETCH_USER: 'FETCH_USER',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
  FETCH_USER_FAILURE: 'FETCH_USER_FAILURE',
};

export const actions = {
  resetUser: () => ({ type: types.RESET_USER }),
  fetchUser: () => ({ type: types.FETCH_USER }),
  fetchUserSuccess: profile => ({
    type: types.FETCH_USER_SUCCESS,
    payload: {
      profile,
    },
  }),
  fetchUserFailure: () => ({ type: types.FETCH_USER_FAILURE }),
};

const initialState = {
  data: {},
  loadingStatus: loadingState.EMPTY,
  errorCode: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_USER:
      return {
        ...initialState,
      };
    case types.FETCH_USER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.profile,
        },
        loadingStatus: loadingState.READY,
      };
    default:
      return state;
  }
};

export default reducer;

export const getProfile = state => state.profile.data;
export const getLoadingStatus = state => state.profile.loadingStatus;

export const getProfileInfo = (state, property) => state.profile.data[property];

export const getAvatar = state => getProfileInfo(state, 'avatar');
export const getFirstName = state => getProfileInfo(state, 'firstName');
export const getUserID = state => getProfileInfo(state, 'userId');
export const getRegion = state => getProfileInfo(state, 'region');

export const getLoginType = state => getProfileInfo(state, 'loginType');

export const getUserEmail = state => getProfileInfo(state, 'email');

export const getUsername = state => getProfileInfo(state, 'username');

export const getUserPhone = createSelector(
  getProfile,
  data => `${data.countryCode}-${data.phone}`
);

export const getSchool = state => getProfileInfo(state, 'schoolName');
export const getGrade = state => getProfileInfo(state, 'gradeName');
export const getRole = state => getProfileInfo(state, 'role');



// WEBPACK FOOTER //
// ./app/redux/profile.js